/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DataTransferOperationType } from '../models/DataTransferOperationType';

/**
* Metadata fields specific to DATA_TRANSFER metering dimension. 
*/
export class CostRecordMetadataDataTransfer {
  'operationType': DataTransferOperationType;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operationType",
      "baseName": "operationType",
      "type": "DataTransferOperationType",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CostRecordMetadataDataTransfer.attributeTypeMap;
  }

  public constructor() {
  }
}



